module.exports = __webpack_public_path__ + "static/media/bv.4a3cbeed.svg";